import React from "react";
import { Image as ImageIcon } from "lucide-react";
import GalleryEditor from "../GalleryEditor";
import { SectionTitle } from "../primitives";
import { PHOTO_MIN, PHOTO_MAX } from "../constants";

export default function Step3Gallery({ form, set }) {
  return (
    <div className="space-y-5">
      <SectionTitle icon={ImageIcon} title="Gallery"
        subtitle={`Upload between ${PHOTO_MIN} and ${PHOTO_MAX} photos. Choose a main photo and reorder by drag.`} />
      <GalleryEditor
        value={form.gallery}
        onChange={(gallery) => {
          // Cover photo defaults to main if none set
          const main = gallery.find(g => g.is_main && g.type === "image");
          set({ gallery, cover_photo: form.cover_photo || main?.url || "" });
        }}
      />
    </div>
  );
}
